import React, { useCallback, useMemo } from 'react';
import { Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { gambleStore } from '../../../store/gambleStore';
import IconBackGround from '../../common/iconBackGround';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { bettingPartStore } from '../../../store/bettingPartStore';
import { isMobile } from '../../../core/helpers/isMobile';
import { gameStore } from '../../../store/gameStore';
import { userInfoStore } from '../../../store/userInfoStore';

const GambleIcon = observer(({ x = 0, y = 0 }) => {
  const { isAutoBetStart } = bettingPartStore;
  const { hasGamble, gambleInfo, setIsShowGamblePopup } = gambleStore;
  const { replayData } = gameStore;
  const gameGambleData = userInfoStore.isReplay ? replayData?.gambleResult : gambleInfo;
  const { gambleIcon, gambleDisabledIcon } = useMemo(() => {
    return getGameImages();
  }, []);

  const handleSelectGamble = useCallback(() => {
    if (gambleInfo) {
      setIsShowGamblePopup(true);
    }
  }, [setIsShowGamblePopup, gambleInfo]);

  if (!hasGamble) {
    return null;
  }

  return (
    <IconBackGround
      x={x}
      y={y}
      handleSelect={handleSelectGamble}
      isDisabled={!gambleInfo || isAutoBetStart}
    >
      <Sprite
        texture={gameGambleData != null && !isAutoBetStart ? gambleIcon : gambleDisabledIcon}
        anchor={0.5}
        scale={isMobile() ? 0.77 : 0.5}
      />
    </IconBackGround>
  );
});

export default GambleIcon;
